const basebapth = "https://api.example.com";

// once we get the actual api we will create url here and import it in to actions file and make api calls
const addAgesTreatedApiUrl = `${basebapth}/addAgesTreatedApiUrl`;

export { addAgesTreatedApiUrl, basebapth };